import React, { useState } from "react";
import "./VmListComponent.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import Table from "react-bootstrap/Table";
import eyeTag from "../../../../assests/eyeTag.svg";
import search from "../../../../assests/search.svg";
import emotions7 from "../../../../assests/emotions7.svg";
import Button from "@mui/material/Button";
import { useNavigate, useParams } from "react-router-dom";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import editsvg from "../../../../assests/edit.svg";
import LoadingSpinner from "../../../Loading/component";

const VmListComponent = (props) => {
  const { id } = useParams();
  const [showStatusList, setShowStatusList] = useState(false);
  const navigate = useNavigate();

  const handleStatusClick = (id) => {
    setShowStatusList(!showStatusList);
  };

  const handleClick = () => {
    navigate("/");
  };

  const handleVMCreation = () => {
    navigate(`/home/configuration/vmcreation/newvmcreation`);
  };

  const goback = () => {
    navigate(-1);
  };

  const handleVmDetails = (id) => {
    navigate(`/home/configuration/vmdetails/${id}`);
  };

  const handleVMEdit = (id) => {
    navigate(`/home/configuration/vmeditdetails/${id}`);
  };

  const getStatusColorClass = (status) => {
    switch (status) {
      case "Active":
        return "vm-status-active";
      case "Inactive":
        return "vm-status-inactive";
      case "Active-Virtual":
        return "vm-status-active-virtual";
      case "Test":
        return "vm-status-test";
      default:
        return "";
    }
  };

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="vm-list-container">
          <div className="vm-list-sidebar">
            <Sidebar />
          </div>

          <div className="vm-list-content">
            <div className="vm-list-header">
              <h2 className="vm-list-title">
                <img
                  onClick={handleClick}
                  className="vm-list-back-arrow"
                  src={leftArrow}
                  alt="Back"
                />
                VM Management
              </h2>
            </div>
            
            <div className="vm-list-search-container">
              <div className="vm-list-search-input-container">
                <input
                  type="search"
                  placeholder="Search by VM ID / VM name"
                  value={props.searchValue}
                  onKeyPress={props.handleKeyPress}
                  onChange={props.handleSearchInputChange}
                  className="vm-list-search-input"
                />
                <button
                  className="vm-list-search-button"
                  onClick={props.handleSearchClick}
                >
                  <img src={search} alt="Search" />
                </button>
              </div>

              <div className="vm-list-add-button-container">
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="contained"
                    onClick={handleVMCreation}
                    startIcon={<AddIcon />}
                    className="vm-list-add-button"
                  >
                    Add VM
                  </Button>
                </Stack>
              </div>
            </div>
            
            <div className="vm-list-table-wrapper">
              <div className="vm-list-table-container">
                <div ref={props.tableContainerRef} className="vm-list-scroll-container">
                  <Table striped hover className="vm-list-table">
                    <thead>
                      <tr className="vm-list-table-header">
                        <th>Sr.no</th>
                        <th>VM. ID</th>
                        <th>VM Name</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody className="vm-list-table-body">
                      {props.filteredVmList && props.filteredVmList.length > 0 ? (
                        props.filteredVmList.map((item, index) => (
                          <React.Fragment key={item.index}>
                            <tr  className="vm-list-view">
                              <td>{index + 1}</td>
                              <td>{item.id}</td>
                              <td>{item.name}</td>
                              <td>
                                <div className={`vm-list-status-badge ${getStatusColorClass(item.operational_status)}`}>
                                  {item.operational_status}
                                </div>
                              </td>
                              <td className="vm-list-actions-cell">
                                <span
                                  className="vm-list-eye-icon"
                                  onClick={() => props.handleOpenStatusModal(item.id)}
                                >
                                  Change Status
                                </span>
                                <Dialog
                                  open={props.showStatusModal === item.id}
                                  onClose={() => props.handleCloseStatusModal(item.id)}
                                  className="vm-list-status-dialog"
                                >
                                  <DialogTitle >Change Status</DialogTitle>
                                  <DialogContent>
                                    <FormControl variant="outlined" fullWidth>
                                      <InputLabel id="status-label">
                                        Status
                                      </InputLabel>
                                      <Select
                                        labelId="status-label"
                                        id="status-select"
                                        value={props.updateStatus.operational_status_id}
                                        onChange={(e) =>
                                          props.setUpdateStatus({
                                            operational_status_id: e.target.value,
                                          })
                                        }
                                        label="Status"
                                        className="vm-list-status-select"
                                      >
                                        {props.statusList.map((status) => (
                                          <MenuItem key={status.id} value={status.id}>
                                            {status.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      onClick={() => props.handleCloseStatusModal(item.id)}
                                      color="primary"
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      onClick={() => {
                                        props.handleUpdateVmStatus(item.id);
                                        props.handleCloseStatusModal(item.id);
                                      }}
                                      color="primary"
                                    >
                                      Update
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                                <img
                                  src={eyeTag}
                                  onClick={() => handleVmDetails(item.id)}
                                  alt="View"
                                 className="vm-list-eye-icon"
                                />
                                <img
                                  onClick={() => handleVMEdit(item.id)}
                                  src={editsvg}
                                  alt="Edit"
                                 className="vm-list-eye-icon"
                                />
                              </td>
                            </tr>
                          </React.Fragment>
                        ))
                      ) : (
                        <tr className="vm-list-empty-row">
                          <td colSpan="5">
                            <div className="vm-list-empty-container">
                              <img className="vm-list-empty-image" src={emotions7} alt="No VMs" />
                              <p className="vm-list-empty-message">No VM Found</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VmListComponent;